import { render, staticRenderFns } from "./personinfo.vue?vue&type=template&id=b9823e22&scoped=true&"
import script from "./personinfo.vue?vue&type=script&lang=js&"
export * from "./personinfo.vue?vue&type=script&lang=js&"
import style0 from "./personinfo.vue?vue&type=style&index=0&id=b9823e22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9823e22",
  null
  
)

export default component.exports